import { createFileRoute } from "@tanstack/react-router";
import { CatalogManager } from "@/components/feature/media/catalog-manager";
import { media, type AdCategoryOut } from "@/lib/api";

export const Route = createFileRoute("/_auth/media/ad-categories")({
  component: AdCategoriesPage,
});

function AdCategoriesPage() {
  return (
    <CatalogManager<AdCategoryOut>
      title="Categorías de aviso"
      description="Clasificación transversal (Operaciones, Legal, etc.). Usadas como dimensión adicional de filtrado en reportes."
      queryKey={["media", "ad-categories"]}
      list={() => media.listAdCategories({})}
      create={(body) => media.createAdCategory(body)}
      patch={(id, body) => media.patchAdCategory(id, body)}
      remove={(id) => media.deleteAdCategory(id)}
      withColor
    />
  );
}
